
export type ModalSize = 'small' | 'medium' | 'large';

/**
 * Enum representing predefined size options.
 */
export enum ModalSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
